import { Col, Container, Row } from "react-bootstrap";
import PropertyAmenityForm from "../../../Components/Forms/PropertyAmenityForm/PropertyAmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useAddNewPropertyAmenityMutation } from "../../../services/bClientApi";
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook";
import useMyPropertiesSelectValues from "../../../Hooks/UseMyProperties/UseMyPropertySelectValuesHook";
import useAmenitySelectValues from "../../../Hooks/UseAmenities/useAmenitySelectValuesHook";

export default function AddPropertyAmenityPage() {

    const [
        addNewPropertyAmenity,
        {
            isLoading,
            error
        }
    ] = useAddNewPropertyAmenityMutation()

    const { myProperties } = useMyProperties()
    const propertyOptions = useMyPropertiesSelectValues(myProperties)
    const amenityOptions = useAmenitySelectValues()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const newPropertyAmenity = await addNewPropertyAmenity(values).unwrap()
        if (newPropertyAmenity._id) {
            dispatch(navigateTo(`/property-amenity/${newPropertyAmenity._id}`))
        }
        return newPropertyAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Add Property Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    <PropertyAmenityForm
                        initialValues={{
                            propertyId: '',
                            amenityId: '',
                            overrides: {},
                        }}
                        disabled={isLoading}
                        onSubmit={handleSubmit}
                        propertyOptions={propertyOptions}
                        amenityOptions={amenityOptions}
                    />

                </Col>
            </Row>
        </Container>
    )
}
